import React from 'react';
import { Banner, BannerButton } from '../../../../models';
import BannerButtons from './BannerButtons';
import styles from '../ModalBanner.module.scss';
import { handleHtmlContentLinkClick } from '../../handleHtmlContentLinkClick';

type Props = {
    banner: Banner;
    onImageClick: () => void;
    onButtonClick: (button: BannerButton) => void;
    onContentLinkClick?: (url: string) => void | Promise<void>;
    previewMode?: boolean;
}

const ModalFullContent: React.FC<Props> = ({ banner, onImageClick, onButtonClick, onContentLinkClick, previewMode }) => {
    const hasButtons = !!(banner.buttons && banner.buttons.length > 0);
    const isImageClickable = !previewMode && !!banner.bannerLink;

    return (
        <div className={styles.content}>
            {banner.imageUrl && (
                <div
                    className={styles.imageLink}
                    onClick={onImageClick}
                    style={{ cursor: isImageClickable ? 'pointer' : 'default' }}
                >
                    <img src={banner.imageUrl} alt={banner.title} className={styles.image} />
                </div>
            )}
            {banner.title && (
                <h2 className={styles.title}>{banner.title}</h2>
            )}
            <div
                className={styles.text}
                onClick={onContentLinkClick ? e => { void handleHtmlContentLinkClick(e, onContentLinkClick); } : undefined}
                dangerouslySetInnerHTML={{ __html: banner.text ?? '' }}
            />
            {hasButtons && (
                <BannerButtons
                    buttons={banner.buttons}
                    onButtonClick={onButtonClick}
                    size="middle"
                    className={styles.buttons}
                />
            )}
        </div>
    );
};

export default ModalFullContent;
